module.exports = __webpack_public_path__ + "img/administracja.bec0d5c6.svg";